// Canonical 5-value citation classification, mirroring apps/api's DomainType
// (apps/api/src/lib/intelligence/citations.ts). Shared here so every
// dashboard consumer of `/api/sources` renders the same colours/labels.

export type SourceType = 'Own' | 'Editorial' | 'UGC' | 'Reference' | 'Competitor'

export const SOURCE_TYPES: SourceType[] = ['Own', 'Editorial', 'UGC', 'Reference', 'Competitor']

export function isSourceType(value: unknown): value is SourceType {
  return typeof value === 'string' && (SOURCE_TYPES as string[]).includes(value)
}

// SVG hex values (light theme — CSS vars can't be used in SVG attributes).
export const SOURCE_TYPE_COLORS: Record<SourceType, string> = {
  Own: '#10b981',
  Editorial: '#6366f1',
  UGC: '#3b82f6',
  Competitor: '#ef4444',
  Reference: '#f59e0b',
}

export const SOURCE_TYPE_BADGE_CLASSES: Record<SourceType, string> = {
  Own: 'bg-feedback-success/10 text-feedback-success border-feedback-success/25',
  Editorial: 'bg-brand-accent/10 text-brand-accent border-brand-accent/25',
  UGC: 'bg-feedback-info/10 text-feedback-info border-feedback-info/25',
  Competitor: 'bg-feedback-error/10 text-feedback-error border-feedback-error/25',
  Reference: 'bg-feedback-warning/10 text-feedback-warning border-feedback-warning/25',
}

export const SOURCE_TYPE_DESCRIPTIONS: Record<SourceType, string> = {
  Own: 'Your own domain',
  Editorial: 'Authoritative publications & blogs',
  UGC: 'Reddit, Quora, review platforms',
  Competitor: 'Competitor brand pages',
  Reference: 'Wikipedia, dictionaries, encyclopaedias',
}

// Defensive fallback for values outside the known SourceType union (e.g. a
// future backend contract drift) — matches the existing `?? clsMap['Editorial']`
// pattern so an unrecognized type still renders styled, not blank.
export function getSourceTypeBadgeClass(type: string): string {
  return SOURCE_TYPE_BADGE_CLASSES[type as SourceType] ?? SOURCE_TYPE_BADGE_CLASSES.Editorial
}
